import React, { useState, useEffect } from "react";

import { API_URL } from './config';

function VerifyEmail() {
  const [status, setStatus] = useState("pending");
  const [message, setMessage] = useState("");

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    if (!token) {
      setStatus("error");
      setMessage("Verification token is missing.");
      return;
    }
    fetch(API_URL + "/signup/verify", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ token }),
    })
      .then(async (res) => {
        const data = await res.json();
        if (res.ok && data.success) {
          setStatus("success");
          setMessage("Your email has been verified! You may now log in.");
        } else {
          setStatus("error");
          setMessage(data.detail || data.message || "Verification failed.");
        }
      })
      .catch(() => {
        setStatus("error");
        setMessage("Verification failed due to a network error.");
      });
  }, []);

  return (
    <div style={{ maxWidth: 400, margin: "80px auto", textAlign: "center" }}>
      <h2>Email Verification</h2>
      {status === "pending" && <p>Verifying your email...</p>}
      {status !== "pending" && <p>{message}</p>}
      {status === "success" && (
        <a href="/signin" style={{ marginTop: 20, display: "inline-block" }}>
          Go to Sign In
        </a>
      )}
    </div>
  );
}

export default VerifyEmail;
